module.exports = __webpack_public_path__ + "static/media/WheatIcon.a4ccd4b8.svg";